import { render, staticRenderFns } from "./about.vue?vue&type=template&id=d5810d20&"
import script from "./about.vue?vue&type=script&lang=ts&"
export * from "./about.vue?vue&type=script&lang=ts&"
import style0 from "./about.vue?vue&type=style&index=0&id=d5810d20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AboutHero: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/about/AboutHero.vue').default,AboutMission: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/about/AboutMission.vue').default})
